export default {
  menu: {
    dashboard: 'Panel',
    invoices: 'Facturas',
    transactions: 'Transacciones',
    analytics: 'Analíticos',
    remittance: 'Remittances',
    buyers: 'Compradores',
    account: 'Detalles de la cuenta',
    bankAccounts: 'Cuentas bancarias',
    support: 'Soporte',
    createInvoice: 'Agregar nueva factura',
    activity: 'Actividad',
    resources: 'Recursos',
    new: 'Nueva',
    masterBL: 'Lista de máster BL',
    holiday: 'Lista de feriados para bancos',
    chargesCalculator: 'Calculadora de costos',
    checkLimitsHere: 'Revisar límites'
  },
  dashboard: {
    htmlTitle: 'Panel | Drip Portal',
    title: 'Panel - MX',
    addInvoiceBtn: 'Agregar factura',
    offlineBanner: {
      in: {
        title: 'Nuestra empresa tendrá un día festivo el 9 de mayo, jueves.',
        text: 'No podremos responder correos electrónicos, consultas en el portal o procesar ningún financiamiento. El equipo y el sistema volverán a estar en línea el viernes, 10 de mayo.',
        writtenBy: ' - Equipo Drip Capital'
      }
    },
    quickGlance: {
      pending: {
        type: 'Facturas',
        text: 'Pendientes'
      },
      outstanding: {
        type: 'Facturas con',
        text: 'saldo pendiente'
      },
      collections: {
        type: 'Factura',
        text: 'vencida'
      },
      settled: {
        type: 'Factura',
        text: 'liquidada'
      },
      helpTexts: {
        pending: 'Pendientes',
        advance: 'Facturas',
        advanced: 'Financiadas',
        invoices: 'Facturas',
        settlement: 'Liquidaciones'
      }
    },
    accountNumbers: {
      title: 'Cuenta de Drip',
      totalLimitLabel: 'Límite total de Drip',
      progressLabel: 'Límite utilizado de Drip',
      outstandingLabel: 'Cargos pendientes',
      settlementLabel: 'Liquidación pendiente',
      increaseLimit: 'Incrementar mi límite',
      requestModal: {
        loading: 'Cargando...',
        ok: 'OK',
        successMessage:
          'Tu solicitud ha sido registrada. Nos pondremos en contacto pronto.'
      }
    },
    pricingDetails: {
      title:
        'La estructura de precios se ha actualizado. Los nuevos términos aplican a partir del ',
      desc: 'Tu nuevo costo es de',
      effective: ', efectivo a partir del',
      link: 'Da clic aquí para consultar más detalles.',
      modalTitle: 'Detalles de precios'
    },
    pendingInvoicesWidget: {
      title: 'Facturas pendientes de recibir adelanto',
      viewAll: 'Ver todas las facturas pendientes →',
      table: {
        reference: 'Referencia',
        importer: 'Importador',
        value: 'Valor de la factura',
        status: 'Estatus',
        actions: 'Accioness'
      },
      view: 'Ver →',
      editText: 'Edit',
      noPending: 'No tienes ninguna factura pendiente. Haz click',
      here: 'aquí',
      addNew: 'para agregar una factura.',
      invoiceTableFields: [
        {
          key: 'reference',
          label: 'Número de referencia'
        },
        {
          key: 'importer',
          label: 'Importador'
        },
        {
          key: 'value',
          label: 'Valor de la factura'
        },
        {
          key: 'stage_human',
          label: 'Estatus'
        },
        {
          key: 'actions',
          label: 'Acciones'
        }
      ],
      status: {
        'Docs Pending': 'Documentos pendientes',
        'Exporter E-Sign Pending': 'E-firmar Requerido',
        'Exporter E-Sign Generated': 'E-firmar Requerido',
        'Invoice Processing': 'Procesando',
        'Basic Info Pending': 'Información básica pendiente',
        Draft: 'Borrador',
        'Buyer E-Sign Pending': 'Firma electrónica de comprador pendiente',
        Hold: 'Hold',
        Pending: 'Pendiente',
        Processing: 'Procesando',
        Approved: 'Aprobado',
        Advanced: 'Adelantado',
        Paid: 'Pagado',
        Settled: 'Liquidado',
        'Partial Advanced': 'Adelantado parcialmente',
        'Partial Payment': 'Pago parcial',
        'Pending Settlement': 'Liquidación pendiente',
        'Auto Advanced': 'Auto Adelantado',
        NPA: 'NPA',
        Claim: 'Afirmar',
        Outdated: 'Anticuado',
        'Auto Settled': 'Auto Liquidado',
        Overdue: 'Overdue',
        'Follow Up': 'Follow Up',
        Revised: 'Revisado',
        'Revision Pending': 'Revisión pendiente',
        'Review and Submit': 'sRevisión Pendiente',
        'E-Sign Pending': 'E-firmar Pendiente',
        'Physical Docs Pending': 'Procesando'
      }
    },

    advanceInvoicesWidget: {
      title: 'Facturas Avanzadas',
      invoiceTableFields: [
        {
          key: 'date',
          label: 'Fecha'
        },
        {
          key: 'reference',
          label: 'Referencia de factura.'
        },
        {
          key: 'importer',
          label: 'Importador'
        },
        {
          key: 'type',
          label: 'Tipo'
        },
        {
          key: 'value',
          label: 'Valor'
        },
        {
          key: 'action',
          label: 'Comportamiento'
        }
      ],
      noRecentTransactions:
        'No tienes ninguna transacción reciente. Vuelva a consultar en unos días una vez que haya procesado algunas facturas.',
      status: {
        advance: 'Avance',
        payment: 'Pago',
        settlement: 'Asentamiento'
      },
      viewAll: 'Ver facturas avanzadas →',
      table: {
        reference: 'Referencia',
        importer: 'Importador',
        value: 'Valor de la factura',
        status: 'Estado',
        actions: 'Comportamiento'
      }
    },
    transactionsWidget: {
      title: 'Transacciones recientes',
      viewAll: 'Ver todas las transacciones',
      table: {
        reference: 'Referencia',
        importer: 'Importadora',
        value: 'Valor de la factura',
        status: 'Estatus',
        actions: 'Accioness'
      },
      noRecentTransactions:
        'No tienes transacciones recientes. Puedes volver a revisar una vez tengas facturas procesadas.',
      invoiceTableFields: [
        {
          key: 'date',
          label: 'Fecha'
        },
        {
          key: 'reference',
          label: 'Referencia de la factura'
        },
        {
          key: 'importer',
          label: 'Importador'
        },
        {
          key: 'type',
          label: 'Tipo'
        },
        {
          key: 'value',
          label: 'Valor'
        },
        {
          key: 'action',
          label: 'Comportamiento'
        }
      ],
      status: {
        advance: 'Adelantar',
        payment: 'Pago',
        settlement: 'Liquidación'
      }
    },
    promos: {
      comingSoon: 'Rastreo de envíos pronto...',
      track: 'Rastrea tu envío',
      analytics: {
        title: 'Crece tu negocio',
        desc: 'Pronto encontrarás analíticos para ayudarte a crecer tu negocio'
      },
      app: {
        title: 'La app de Drip está aquí.',
        subtitle:
          'Experimenta el futuro del financiamiento con nuestra nueva app móvil. Disponible en las principales tiendas de aplicaciones.',
        links: [
          {
            icon: 'playstore.svg',
            title: 'Descarga de Google Play',
            link: 'https://play.google.com/store/apps/details?id=com.dripcapital.portal'
          },
          {
            icon: 'app-store.svg',
            title: 'Descarga de App Store',
            link: 'https://apps.apple.com/us/app/drip-capital/id1538574258'
          }
        ]
      }
    },
    openInvoiceCard: {
      title: 'Newly launched',
      subtitle:
        'Manage your open invoices and enable payments in INR to save more!',
      invoicesCount: {
        amend: 'out of',
        append: 'invoices',
        subtitle: 'Are set for INR payments'
      },
      button: 'Currency settings'
    }
  },
  comingSoon: 'Pronto',
  transactions: {
    index: {
      htmlTitle: 'Transacciones | Portal Drip',
      title: 'Transacciones',
      fields: {
        advances: [
          {
            key: 'disbursed',
            label: 'Fecha de pago'
          },
          {
            key: 'invoice_reference',
            label: 'Referencia de la factura'
          },
          {
            key: 'invoice_importer',
            label: 'Importador'
          },
          {
            key: 'customer_bank',
            label: 'Banco del remitente'
          },
          {
            key: 'value',
            label: 'Valor'
          },
          {
            key: 'action',
            label: 'Comportamiento'
          }
        ],
        payments: [
          {
            key: 'dated',
            label: 'Fecha de pago'
          },
          {
            key: 'invoice_reference',
            label: 'Referencia de la factura'
          },
          {
            key: 'invoice_importer',
            label: 'Importador'
          },
          {
            key: 'value',
            label: 'Valor'
          }
        ],
        settlements: [
          {
            key: 'settlement_date',
            label: 'Fecha de la liquidación'
          },
          {
            key: 'reference',
            label: 'Referencia de la factura'
          },
          {
            key: 'importer',
            label: 'Importador'
          },
          {
            key: 'settlement_date',
            label: 'Fecha de la liquidación'
          },
          {
            key: 'settlement_customer_bank',
            label: 'Banco del remitente'
          },
          {
            key: 'value',
            label: 'Valor'
          },
          {
            key: 'action',
            label: 'Comportamiento'
          }
        ]
      },
      transactionFilters: [
        {
          text: 'Adelantos',
          value: 'advances'
        },
        {
          text: 'Pagos',
          value: 'payments'
        },
        {
          text: 'Liquidaciones',
          value: 'settlements'
        }
      ]
    }
  },
  holidays: {
    index: {
      title: 'Recursos',
      list: 'Lista de feriados para bancos'
    }
  },
  chargesCalculator: {
    index: {
      title: 'Recursos',
      list: 'Calculadora de costos',
      desc: 'INDIA BANK HOLIDAY LIST',
      caption:
        'Our partner banks will be closed on these days. All advances, settlements, and bank cover letter applications will be processed on the next working day.',
      invoiceDetails: {
        title: 'DETALLES DE LA FACTURA',
        headers: {
          particulars: 'PARTICULARES',
          value: 'VALOR'
        },
        fieldItems: {
          value: 'Valor de la factura',
          advanceTotal: 'Adelanto total',
          disbursedDate: 'Fecha de desembolso',
          dueDate: 'Fecha de vencimiento',
          receivedDate: 'Fecha de recepción',
          receivedAmount: 'Cantidad recibida (esperada)'
        }
      },
      calcDetailsTable: {
        title: 'CÁLCULOS DETALLES',
        headers: {
          particulars: 'PARTICULARES',
          expected: 'CANTIDAD ESPERADA EN FECHA DE VENCIMIENTO',
          asOn: 'AL'
        },
        firstRow: {
          firstColumn:
            'Estos son los cargos estimados con base en la fecha de vencimiento de la factura',
          secondColumn:
            'De acuerdo con la fecha seleccionada, estos son los cargos en la factura. La fecha estimada será cuando los fondos se reflejen en tu cuenta.'
        },
        duration: 'Duración',
        stepUpDbrDuration: 'DBR Variabilidad días',
        stepUpDbrRate: 'DBR tasa variable aplicada',
        overdue: 'Días vencidos',
        factoringRate: 'Tasa de descuento aplicada',
        factoringFees: 'Comisión de factoraje',
        advanceDuration: 'Plazo transcurrido del adelanto',
        advanceRegularInterest: 'Interés regular del adelanto',
        regularInterest: 'Importe de interés regular',
        overdueInterest: 'Cantidad por intereses vencidos',
        stepUpDbrInterest: 'DBR importe de la tasa de interés variable',
        totalInterest: 'Interés total',
        totalInterestWithoutDBR: 'Interés total',
        totalFees: 'Total de cargos',
        collectionAmount: 'Collection Amount',
        settlementBalance: 'Settlement Balance',
        settlementAdjusts: 'Settlement Adjusts',
        totalSettlement: 'Liquidación total'
      },
      selectInvoice: {
        label: 'SELECCIONAR FACTURA',
        placeHolder: 'SELECCIONAR FACTURA',
        text: 'Selecciona una factura para calcular los cargos',
        noResults: 'No pudimos encontrar facturas para '
      }
    }
  },
  masterBl: {
    heading:
      'Las compañías navieras enlistadas aquí están aprobadas por Drip para ser consideradas como máster bill of lading (Master BL)  ',
    searchLine: 'Buscar compañía naviera',
    inputPlaceholder: 'Ingresar compañía naviera',
    sortBy: {
      heading: 'Ordenar por',
      atoz: 'A a Z',
      ztoa: 'Z a A'
    },
    sorry: {
      heading: 'Lo sentimos, no pudimos encontrar resultados para',
      line1: '¿No encuentras lo que buscas?',
      line2: 'Contacta a tu gerente de cuenta o escríbenos a',
      email: 'dripassist@dripcapital.com'
    }
  },
  buyers: {
    index: {
      htmlTitle: 'Compradores | Portal Drip',
      title: 'Compradores',
      limits: 'Límites',
      placeHolder: 'Buscar un comprador',
      increaseLimit: 'Incrementar el límite',
      notFound: 'No Comprador Encontrado',
      buyerFilters: [
        {
          text: 'Todas',
          value: 'All'
        },
        {
          text: 'Activo',
          value: 'Active'
        },
        {
          text: 'Solo liquidación',
          value: 'Setoff Only'
        },
        {
          text: 'Aprobado',
          value: 'Approved'
        },
        {
          text: 'Procesando',
          value: 'Processing'
        },
        {
          text: 'Pendiente',
          value: 'Pending'
        },
        {
          text: 'Rechazado',
          value: 'Rejected'
        }
      ],
      buyerFields: [
        {
          key: 'importer',
          label: 'Nombre',
          sortable: true
        },
        {
          key: 'new_portal_status',
          label: 'Estatus',
          class: 'status-cell',
          sortable: true
        },
        {
          key: 'product_based_limit',
          label: 'Límite Drip',
          sortable: true
        },
        {
          key: 'balance',
          label: 'Balance pendiente',
          sortable: true
        },
        {
          key: 'invoices_total',
          label: 'Número de facturas financiadas',
          sortable: true
        },
        {
          key: 'invoice_acknowledgement_required?',
          label: '¿Se requiere confirmación de factura?',
          sortable: true
        },
        {
          key: 'full_recourse_label?',
          label: 'Tipo de recurso',
          sortable: true
        },
        {
          key: 'invoices_value_total',
          label: 'Valor de las facturas financiadas',
          sortable: true
        },
        {
          key: 'action',
          label: '',
          sortable: true
        }
      ],
      fullRecourse: 'Con recurso',
      limitedRecourse: 'Recurso limitado',
      acknowledgement: {
        yes: 'Sí',
        no: 'No'
      },
      status: {
        Processing: 'Procesando',
        'On Hold': 'En espera',
        Rejected: 'Rechazado',
        'Funding Available': 'Fundable'
      }
    },
    modal: {
      paragraph:
        'Está enviando una factura para un comprador que no está activo. El anticipo de esta factura solo se procesará si el comprador vuelve a estar activo.',
      cancel: 'Cancelar',
      okay: 'OK, Entendido'
    },
    single: {
      summary: {
        fields: {
          details: 'Detalles del comprador',
          name: 'Nombre del comprador',
          status: 'Estatus',
          productLimit: 'Puede recibir financiamiento por hasta',
          product_based_limit: 'Límite Drip',
          balance: 'Actualmente pendiente'
        }
      },
      pricing: {
        title: 'Detalles del precio',
        banner: 'Los nuevos términos aplican a partir del ',
        fields: {
          invoiceValue: 'del valor neto de la factura',
          advanceRate: 'Tasa de adelanto',
          factoringComission: 'Comisión de factoraje',
          interestRate: 'Tasa de interés',
          calculation: 'Calculado diariamente'
        }
      },
      banking: {
        title: 'Detalles bancarios de Drip Capital',
        desc: 'Consulte la siguiente sección para ver las instrucciones del banco Drip Capital que se colocarán en la factura',
        fields: {
          bankName: 'Nombre del banco',
          bankAddress: 'Dirección del banco',
          aba: 'ABA Routing',
          accName: 'Nombre de la cuenta',
          accNo: 'Número de cuenta',
          swift: 'Swift'
        }
      },
      product: {
        title: 'Especificaciones del producto',
        fields: {
          product: 'Producto',
          paymentTenor: 'Términos de pago máximos',
          docFee: 'Comisión por manejo de documentos',
          currency: 'Moneda',
          cheque: 'Tipo de cheque'
        }
      },
      buyer: {
        plan: {
          ofNetInvoiceValue: 'Del valor neto de la factura',
          upto: 'Hasta',
          days: 'Días:',
          pa: 'al año',
          progressLabel: 'Used Límite',
          totalLimitLabel: 'Límite total'
        },
        product: {
          daysFrom: 'Días desde'
        }
      }
    },
    add: {
      htmlTitle: 'Agregar comprador | Portal Drip',
      title: 'Agregar comprador',
      form: {
        name: 'Nombre del comprador',
        country: 'País del comprador',
        address: 'Dirección del comprador',
        paymentTerms: 'Términos de pago',
        shipmentTerms: 'Términos de envío',
        pastSales: 'Ventas en los últimos 12 meses (dólares americanos)',
        futureSales:
          'Ventas planeadas en los próximos 12 meses (dólares americanos)',
        creditPeriod: 'Tiempo de pago',
        creditFrom: 'Crédito de',
        experience: 'Años de relación',
        currency: 'Moneda',
        routing: 'Envío de documentos',
        release: 'Entrega de documentos',
        paymentTenor: 'Tiempo de pago',
        daysFrom: 'Días de',
        drip_limit: 'Límite requerido',
        relatedParty: '¿Es parte relacionada?',
        writeOffs: '¿Pagos incumplidos?',
        submit: 'Enviar comprador para aprobación',
        next: 'Siguiente paso',
        back: 'Atrás',
        helpText: {
          uploads: {
            'sample-po': {
              title: 'Adjuntar orden de compra del pedido anterior',
              desc: 'Orden de compra debe estar en el comprador'
            },
            'sample-ci': {
              title: 'Adjuntar factura de la orden anterior',
              desc: 'La factura debe contener los términos de pago para verificar los detalles enviados'
            }
          },
          country: {
            title: 'Seleccionar país del comprador',
            desc: 'El comprador debe ser una entidad registrada en este país'
          },
          name: {
            title: 'Nombre del comprador exacto',
            desc: 'Ingresar exactamente como está en la orden de compra y factura'
          },
          address: {
            title: 'Dirección exacta del comprador',
            desc: 'Ingresar nombre exacto de la calle y código postal'
          },
          routing: {
            title: 'Cómo envías documentos a tu cliente?',
            desc: 'Documentos como la carta porte original, factura original, etc.'
          },
          release: {
            title: '¿Cuándo envías los documentos?',
            desc: 'Documentos como la carta porte original, factura original, etc.'
          },
          paymentTenor: {
            title: '¿Cuándo te paga el comprador?',
            desc: 'Seleccionar comprador'
          },
          drip_limit: {
            title: '¿Cuál es el límite requerido para este comprador?',
            desc: 'Utilizando el valor de las facturas en periodos pico, calcula el límite requerido para este comprador'
          },
          years_selling: {
            title: 'Relación con el comprador',
            desc: 'Años de trabajar con este comprador, con éste u otro nombre del comprador'
          }
        },
        others: 'Otros, por favor especifique',
        required: 'Este campo es requerido',
        removeFile: 'Quitar el archivo'
      },
      progressSteps: [
        {
          step: '01',
          text: 'Cargas'
        },
        {
          step: '02',
          text: 'Información del comprador'
        },
        {
          step: '03',
          text: 'Operaciones'
        }
      ],
      business: {
        title: 'Agregar relación de negocios'
      },
      information: {
        title: 'Información del comprador'
      }
    },
    buyerFilters: [
      {
        key: 'Funding Available',
        label: 'Financiamiento disponible'
      },
      {
        key: 'Processing',
        label: 'Procesando'
      },
      {
        key: 'On Hold',
        label: 'En espera'
      },
      {
        key: 'Rejected',
        label: 'Rechazado'
      }
    ]
  },
  invoices: {
    add: {
      htmlTitle: 'Agregar factura | Portal Drip',
      title: 'Agregar factura',
      titles: {
        invoiceInfo: 'Información de factura',
        shippingDetails: 'Detalles de envío',
        fundingInfo: 'Información de financiamiento',
        uploadDocs: 'Cargar documentos',
        review: 'Revisar y enviar'
      },
      subTitle: {
        fundingInfo:
          'Se requieren los datos bancarios del comprador en las facturas de banco a banco para generar cartas de presentación.',
        review: 'Por favor revise la siguiente información'
      },
      form: {
        buyer: 'Comprador',
        currency: 'Divisa',
        reference: 'Referencia',
        grossValue: 'Valor bruto',
        advanceReceived: 'Adelanto recibido',
        value: 'Valor neto de factura',
        maxAmount: 'Monto máximo financiable',
        invoiceDate: 'Fecha de factura',
        userDueDate: 'Fecha estimada de vencimiento',
        shippingBillDate: 'Fecha de la carta de embarque',
        shippingBillNumber: 'Pedimento No.',
        blNo: 'Número de carta porte',
        blDate: 'Fecha de la carta porte',
        container: 'Número del contenedor',
        shippingLine: 'Línea de embarque',
        consignee: 'Consignatario',
        vesselName: 'Nombre del buque',
        clientBankDetailId: 'Banco del desembolso',
        fundingType: 'Tipo de financiamiento',
        fundingTypes: {
          adjustExisting: 'Ajustar contra lo existente',
          fundNew: 'Financiar nueva factura'
        },
        customerNotes: 'Notas adicionales',
        submit: 'Guardar y proceder',
        invoiceReason: {
          funding: 'Quiero financiar esta factura',
          adjustment: 'Quiero ajustar el saldo con otras facturas'
        },
        adjustedInvoices: 'Facturas a ser ajustadas',
        response: {
          invoiceExists: 'Esta factura ya existe'
        },
        seller: 'Vendedor'
      },
      helpers: {
        buyer: {
          label: 'Comprador',
          placeHolder: 'Seleccione Comprador',
          notFound:
            'No se encontraron elementos. Considere cambiar la consulta de búsqueda.'
        },
        invoiceNo: {
          label: 'Número de factura',
          placeHolder: 'Número de factura para referencia futura'
        },
        invoiceDate: {
          label: 'Fecha de factura',
          placeHolder: 'Fecha de la factura'
        },
        currency: {
          label: 'Divisa',
          placeHolder: 'Seleccione Divisa'
        },
        grossValue: {
          label: 'Valor bruto',
          placeHolder: 'Ingrese la cantidad'
        },
        advanceReceived: {
          label: 'Adelanto recibidio del comprador',
          placeHolder: 'Enter Amount'
        },
        netValue: {
          label: 'Valor neto de factura'
        },
        maxValue: {
          label: 'Monto máximo financiable',
          note: 'El monto final puede ser menor sujeto a disponibilidad de límites y otros factores'
        },
        shippingBillDate: {
          label: 'Shipping Bill Date',
          placeHolder: 'Select Shipping Bill Date'
        },
        shippingLine: {
          label: 'Shipping Line',
          placeHolder: 'Enter Shipping Line'
        },
        consignee: {
          label: 'Consignee',
          placeHolder: 'Enter Consignee'
        },
        vesselName: {
          label: 'Vessel Name',
          placeHolder: 'Enter Vessel Name'
        },
        userDueDate: {
          label: 'Fecha de vencimiento estimada',
          placeHolder: 'Seleccione Vencer Fecha'
        },
        containerNo: {
          label: 'Container Number',
          placeHolder: 'Enter Container Number'
        },
        blNo: {
          label: 'BL Number',
          placeHolder: 'Enter BL Number'
        },
        blDate: {
          label: 'BL Date',
          placeHolder: 'Select BL Date'
        },
        fundingType: {
          label: 'Tipo de financiamiento'
        },
        clientBankDetailId: {
          label: 'Banco de desembolso'
        },
        customerNotes: {
          label: 'Notas adicionales, de ser aplicables',
          placeHolder:
            'Proporcione detalles adicionales sobre su factura para el equipo de operaciones de Drip.'
        },
        adjustedInvoices: {
          label: 'Facturas a ajustar, si las hubiera',
          placeHolder: 'Seleccionar facturas'
        },
        dropFileHere: ' Suelte el archivo aquí',
        uploadFile: 'Subir archivo',
        uploadFiles: 'Subir archivo(s)',
        fileLimitErr: 'Se alcanzó el límite de tamaño de 50 MB',
        uploadMsg:
          'Una vez que haga clic en el botón enviar, no podrá volver a cargar los documentos. Para volver a cargar, comuníquese con su administrador de cuentas.',
        fileTypeError: `No puede cargar archivos de este tipo.`,
        pdfTypeOnly: 'Tipo de archivo no soportado. Puedes subir archivos PDF',
        pdfAndImagesOnly:
          'Tipo de archivo no soportado. Puede cargar archivos PDF y de imagen',
        fileSizeError: 'No puedes agregar más archivos',
        fileSizeAvailableError:
          'No se puede agregar el archivo, el tamaño disponible para cargar el archivo es',
        discrepantInvoice: {
          title: 'Desigualdad encontrada en {docName}, vuelva a cargar',
          commentLabel: 'Comentarios',
          modal: {
            title: 'Ha vuelto a enviar los documentos con éxito.',
            desc: `Debido a la diferencia encontrada en la factura, puede haber un ligero retraso en el procesamiento de la factura.`,
            ok: 'Ok lo tengo'
          }
        }
      },
      actions: {
        next: 'Siguiente',
        save: 'Guardar como borrador',
        back: 'Atrás'
      },
      progressSteps: [
        {
          step: '1',
          text: 'Información de factura'
        },
        {
          step: '2',
          text: 'Detalles de envío'
        },
        {
          step: '3',
          text: 'Información de financiamiento'
        },
        {
          step: '4',
          text: 'Cargar documentos'
        },
        {
          step: '5',
          text: 'Revisar y Enviar'
        }
      ],
      step: 'Paso',
      of: 'De'
    },
    upload: {
      subtitle: 'Agregar documentos de la factura',
      addInvoice: '¿Deseas agregar otra factura?',
      saveUpload: 'Sí, guardar y subir otra factura',
      noSaveProceedEsign: 'No, guardar y proceder a la firma',
      noSaveProceed: 'No, guardar y proceder',
      proceed:
        'Como parte del envío de la factura, cargue todos los documentos y luego proceda con la firma electrónica. ¿Desea agregar otra factura en su lugar? Hágalo y vuelva más tarde para completar el proceso de documentación. Luego, dirígete a la firma electrónica.',
      uploadLater: 'Sí, subir más tarde',
      continue: 'Continuar cargando',
      fileUpload: {
        upload: 'Cargar',
        remove: 'Eliminar el archivo',
        select: 'Haz click aquí para seleccionar el archivo o arrástalo aquí',
        size: '*Max Expediente Talla: 50MB',
        formatMsg: 'Cargue varios documentos en formato PDF'
      },
      continueToEsign: 'Continuar a firma electrónica',
      esign: 'E-Sign',
      pleaseEsign:
        'Por favor, cargue todos los documentos para firmar electrónicamente',
      addMoreInvoices: 'Agregar más facturas',
      toDashBoard: 'Continuar al panel'
    },
    single: {
      printSave: 'Imprimir / Guardar',
      info: {
        title: 'Información de la factura',
        reference: 'Referencia',
        seller: 'Vendedor',
        buyer: 'Comprador',
        invoiceValue: 'Valor de la factura',
        containerNumber: 'Número del contenedor',
        blDate: 'Fecha de la carta porte',
        paymentTerms: 'Términos de pago',
        dueDate: 'Fecha límite de pago',
        poNo: 'Número de orden de compra',
        poDate: 'Fecha de la orden de compra'
      },
      infoV2: {
        invoiceInformation: '1. Información de factura',
        shippingDetails: '2. Detalles de envío',
        fundingInformation: '3. Información de financiamiento'
      },
      disbursements: {
        title: 'Desembolsos',
        advance: 'Adelanto #',
        total: 'Total'
      },
      payments: {
        title: 'Pagos',
        payment: 'Número de pago',
        total: 'Total'
      },
      outstanding: {
        title: 'Pendiente',
        today: 'Hoy',
        amount: 'Monto pendiente',
        chargesCalculationLink:
          'Seleccionar otra fecha para calcular los cargos',
        invoiceChargesCalculation: 'Seleccionar otra fecha',
        expectedTotal: 'Cargos totales esperados',
        viewDetails: 'Ver detalles',
        expectedSettlement: 'Monto esperado de liquidación',
        expectedSettlementHint:
          'Monto pendinte - Desembolsos - Cargos totales esperados',
        expectedTaxCalculation: 'Esperado cálculo de impuestos',
        taxCalculation: 'Cálculo de impuestos',
        isr: 'ISR',
        fourPercentOfTotalCharges: '4% de los cargos totales'
      },
      settlement: {
        title: 'Liquidación',
        total: 'Cargos totales',
        amount: 'Monto de liquidación',
        amountHint: 'Pagos - liquidaciones - cargos totales',
        date: 'Fecha de la liquidación',
        bank: 'Banco de la liquidación',
        viewDetails: 'Ver detalles'
      },
      updates: {
        title: 'Actualizaciones de las facturas',
        on: 'el',
        added_basic_invoice_details: 'Detalles básicos de factura agregados',
        bill_of_lading_uploaded: 'Carte porte cargada',
        commercial_invoice_uploaded: 'Factura comercial cargada',
        shipping_bill_uploaded: 'Pedimento cargado',
        purchase_orders_uploaded: 'Órdenes de compra cargadas',
        packing_list_uploaded: 'Lista de empaque cargada',
        pdc_received: 'PDC recibido',
        bl_received: 'BL recibido',
        documents_generated_for_esign:
          'Documentos generados por firma electrónica',
        e_signed_by: 'Firmado electrónicamente por ',
        invoice_processing_done: 'Procesamiento de factura completado',
        invoice_verified: 'Factura verificada',
        invoice_advanced: 'Factura adelantada',
        buyer_remittance_expected: 'Remesa del comprador esperada',
        buyer_payment_received: 'Pago del comprador recibido',
        invoice_settled: 'Factura liquidada',
        physical_bl_returned: 'BL físico devuelto',
        pdc_returned: 'PDC devuelto',
        invoice_data_verified: 'Datos de factura verificados'
      },
      uploadDocs: {
        commercial_invoice: 'Factura comercial',
        bill_s_of_lading: 'Carta(s) porte',
        purchase_order_s: 'Órdenes de compra',
        shipping_bill_s: 'Pedimento',
        shipping_bill_s_optional: 'Pedimento (Opcional)',
        bill_of_exchange_signable: 'Letra de cambio (Señalizable)',
        bank_cover_letter: 'Carta de presentación del banco',
        packing_list: 'Lista de empaque',
        exporter_documents_checklist:
          'Lista de verificación de documentos del exportador',
        additional_documents: 'Documentos adicionales',
        po: 'Órdenes de compra',
        invoice: 'Factura comercial',
        bl: 'Carta(s) porte',
        prl: 'Purchase Request Letter',
        'packing-list': 'Lista de empaque',
        boe: 'Letra de cambio',
        'unsigned-boe': 'Letra de cambio (Señalizable)',
        sb: 'Pedimento',
        'sb-in': 'Pedimento',
        'sb-pdmt': 'Pedimento',
        coo: 'COO',
        mi: 'Marine Insurance',
        ic: 'Inspection Certificate',
        pdc: 'PDC',
        bld: 'BL Delivery Letter',
        'liner-noc': 'Liner NOC Letter',
        'remitter-note': "Remitter's Note",
        'bank-cover': 'Carta de presentación del banco',
        'exp-checklist': 'Lista de verificación de documentos del exportador',
        supporting: 'Supporting Document',
        attachment: 'Attachment',
        additional: 'Documentos adicionales',
        'invoice-ack': 'Invoice Acknowledgement'
      },
      documents: {
        title: 'Documentos',
        uploaded: 'Cargar documentos',
        date: 'Carga en'
      },
      modals: {
        charges: {
          title: 'Desglose de los cargos',
          expected: 'Esperado',
          factoringFee: 'Tasa de factoraje',
          percentOn: '% en',
          invoiceValue: '(Valor de la factura)',
          interest: 'Interés',
          pa: '% al año',
          on: 'en',
          totalAdvanceFor: '(Adelanto total) para',
          invoiceValueFor: '(Valor de la factura) para',
          days: 'Días',
          regularInterest: 'Interés regular en',
          totalAdvance: 'Adelanto total',
          advance: 'Adelanto #',
          for: 'para',
          overdueInterest: 'Interés atrasado en adelanto total',
          otherFees: 'Otras comisiones',
          processingFee: 'Comisión por procesamiento',
          docFees: 'Comisión por documentos',
          adjustments: 'Ajustes',
          totalCharges: 'Cargos totales'
        }
      },
      statement: {
        title: 'Cálculos de cargos',
        netValue: 'Valor neto de la factura',
        setOffAgainst: 'Partió contra',
        setOffFrom: 'Partir de',
        refNo: 'Número de referencia',
        expectedChargesAsOn: 'Cargos esperados como en',
        today: 'Hoy',
        forInvoices: 'Para las facturas',
        date: 'Fecha',
        transactionType: 'tipo de transacción',
        credit: 'Crédito',
        debit: 'Débito',
        outstanding: 'Saldo adeudado',
        viewDetails: 'Ver detalles',
        closeDetails: 'Cerrar detalles',
        viewCopy: 'Ver copia rápida',
        totalAmount: 'Cantidad total',
        remittanceBank: 'Banco de remesas',
        payeeMemo: 'Memo del beneficiario',
        chooseDate: 'Elija una fecha diferente'
      },
      tabs: {
        submitted: 'Submitted Details',
        details: 'Detalles',
        documents: 'Documentos',
        summary: 'Resumen',
        statement: 'Estado'
      },
      downloadInvoice: 'Descargar aviso',
      noUpdates: 'No Actualizaciones'
    },
    index: {
      title: 'Facturas',
      esignInvoices: 'Firmar facturas',
      addInvoice: 'Agregar factura',
      pending: 'Adelanto pendiente',
      outstanding: 'Adelantado',
      received: 'Liquidación pendiente',
      settled: 'Liquidado',
      searchResults: 'Buscar resultados para',
      searchInvoice: 'Buscar una factura...',
      noInvoices:
        'No se encontraron facturas con los filtros actuales. Por favor cambia los filtros o intenta con otro término de búsqueda',
      view: 'Ver →',
      outstandingFields: [
        {
          key: 'reference',
          label: 'Referencia',
          sortable: true
        },
        {
          key: 'importer',
          label: 'Importador',
          sortable: true
        },
        {
          key: 'value',
          label: 'Valor de la factura',
          sortable: true
        },
        {
          key: 'advanced_date',
          label: 'Fecha de adelanto',
          sortable: true
        },
        {
          key: 'total_advanced',
          label: 'Total adelantado',
          sortable: true
        },
        {
          key: 'payment_total',
          label: 'Pagos recibidos',
          sortable: true
        },
        {
          key: 'outstanding',
          label: 'Pendiente del comprador',
          sortable: true
        },
        {
          key: 'advice_exporter_fees',
          label: 'Cargos esperados',
          sortable: true
        },
        {
          key: 'repayment',
          label: 'Fecha límite',
          sortable: true
        },
        {
          key: 'stage_human',
          label: 'Estatus'
        },
        {
          key: 'actions',
          label: 'Acciones'
        }
      ],
      settledFields: [
        {
          key: 'reference',
          label: 'Referencia',
          sortable: true
        },
        {
          key: 'importer',
          label: 'Importador',
          sortable: true
        },
        {
          key: 'value',
          label: 'Valor de la factura',
          sortable: true
        },
        {
          key: 'advanced_date',
          label: 'Fecha del adelanto',
          sortable: true
        },
        {
          key: 'total_advanced',
          label: 'Total adelantado',
          sortable: true
        },
        {
          key: 'received_amount',
          label: 'Monto recibido',
          sortable: true
        },
        {
          key: 'exporter_fees',
          label: 'Cargos',
          sortable: true
        },
        {
          key: 'settlement',
          label: 'Monto de la liquidación',
          sortable: true
        },
        {
          key: 'settlement_date',
          label: 'Fecha de la liquidación',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Acciones'
        }
      ],
      receivedFields: [
        {
          key: 'reference',
          label: 'Referencia',
          sortable: true
        },
        {
          key: 'importer',
          label: 'Importador',
          sortable: true
        },
        {
          key: 'value',
          label: 'Valor de la factura',
          sortable: true
        },
        {
          key: 'advanced_date',
          label: 'Fecha del adelanto',
          sortable: true
        },
        {
          key: 'total_advanced',
          label: 'Total adelantado',
          sortable: true
        },
        {
          key: 'received_amount',
          label: 'Monto recibido',
          sortable: true
        },
        {
          key: 'exporter_fees',
          label: 'Cargos esperados',
          sortable: true
        },
        {
          key: 'settlement',
          label: 'Monto de la liquidación esperado',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Acciones'
        }
      ],
      pendingFields: [
        {
          key: 'reference',
          label: 'Referencia',
          sortable: true
        },
        {
          key: 'importer',
          label: 'Importador',
          sortable: true
        },
        {
          key: 'value',
          label: 'Valor de la factura',
          sortable: true
        },
        {
          key: 'stage_human',
          label: 'Estatus'
        },
        {
          key: 'actions',
          label: 'Acciones'
        }
      ],
      require: {
        text: 'Mostrar facturar que requieren {filter}',
        information: 'Información crítica',
        documents: 'Documentos críticos',
        esign: 'E-firma'
      },
      exportData: {
        title: 'Datos de exportación',
        exportInvoicesData: 'Datos de las facturas de exportación',
        export: 'Exportación',
        required: 'Este campo es requerido',
        labels: {
          from: 'De',
          to: 'Hasta'
        },
        error: 'Date fields are mandatory',
        errorFailed: 'Download PDF of invoice list failed'
      },
      notFound: 'No Facturas Encontrado',
      editDraft: 'Editar Borrador',
      downloadInvoice: 'Descargar aviso',
      viewInvoice: 'Ver factura'
    },
    warnings: {
      // todo: rethink organization when we add more warnings.
      late: {
        title: 'Nota',
        text: 'Facturas recibidas después de las 8 pm (CST) se procesarán hasta el siguiente día hábil.',
        dismiss: 'Haz click aquí para descartar.'
      }
    },
    tracking: {
      title: 'Rastreo de contenedores',
      container: {
        showMore: 'Mostrar más',
        fetch: 'Obtener datos del contenedor',
        noData: 'No hay información disponible',
        delayed: 'Envío atrasado'
      },
      modal: {
        title: 'Rastreo de contenedor - {containerNumber}'
      }
    },
    esign: {
      title: 'Las siguientes facturas se pueden firmar:',
      noDocs:
        'No pudimos encontrar ninguna factura que requiera una firma electrónica.',
      esignNow: 'Firmar ahora',
      toolTip: 'No está autorizado a Esign',
      nps: {
        modalTitle:
          '¿Qué tan probable es que recomiendes Drip Capital a un amigo o conocido?',
        label1: 'Nada probable',
        label2: 'Extremadamente probable',
        pageNumber1: '1 de 2',
        pageNumber2: '2 de 2',
        btnNext: 'Siguiente',
        btnSubmit: 'Enviar',
        ques1:
          '¿Qué tendríamos que hacer en Drip para ganarnos una mejor recomendación?',
        ques2:
          '¿Qué hacemos ya particularmente bien para merecer tu recomendación? ',
        thanks: '¡Gracias!',
        feedback: 'Retroalimentación enviado correctamente',
        closeModal: 'X',
        placeholder: 'Escriba su recomendación aquí...',
        wnr: 'No se lo recomendaría',
        mr: 'Podría recomendar',
        dr: 'Sin duda lo recomiendo'
      },
      viewAll: 'Ver todas las facturas',
      fields: [
        {
          key: 'reference',
          label: 'Referencia'
        },
        {
          key: 'importer',
          label: 'Importador'
        },
        {
          key: 'value',
          label: 'Valor de la factura'
        }
      ]
    },
    requestQuery: {
      helpText: '¿Necesitas ayuda?',
      requestText: 'Ingresar solicitud',
      modal: {
        subject: 'Subject*',
        subjectPlaceholder: 'Choose a Subject',
        description: 'Describe (optional)',
        successTitle: 'Request Sent',
        successMessage:
          'Thank you for submitting this request. You will receive an email shortly acknowledging your request and a link where you can follow the status of your ticket.'
      }
    }
  },
  account: {
    index: {
      htmlTitle: 'Cuenta | Drip Capital',
      title: 'Cuenta',
      summary: {
        title: 'Resumen',
        fields: {
          limit: 'Límite total de Drip',
          fee: 'Comisión por apertuda',
          ofCreditLimit: 'del límite de crédito'
        }
      },
      pricing: {
        title: 'Detalles del precio',
        fields: {
          advanceRate: 'Tasa de adelanto',
          factoringComission: 'Comisión de factoraje',
          interestRate: 'Tasa de interés',
          invoiceValue: 'del valor neto de la factura',
          ofNetInvoiceValue: 'del valor neto de la factura',
          days: 'días:',
          pa: '',
          upto: 'hasta',
          overdue: 'Tasa por retraso',
          addition: 'Additional',
          desc: 'anual adicional a la tasa de interés aplicado al tiempo de retraso después de un periodo de gracia de 7 días a partir de la fecha de vencimiento'
        }
      },
      product: {
        title: 'Especificaciones del producto',
        fields: {
          paymentTenor: 'Periodo máximo de pago',
          docFee: 'Comisión por manejo de documentos',
          currency: 'Moneda',
          cheque: 'Tipo de cheque',
          daysFrom: 'días desde'
        }
      }
    }
  },
  remittances: {
    listRemittance: {
      title: 'Remesas',
      cardHeading: 'Agregar nueva remesa',
      cardHeading2: 'Agregar una nueva remesa',
      cardTitle: '¡Rellene un sencillo formulario y agregue su remesa!',
      cardDesc:
        '¡Puede agregar una nueva remesa para facturas financiadas y no financiadas!',
      cardDesc2:
        'Puede agregar remesas para facturas financiadas y no financiadas. Para cualquier pregunta o inquietud, comuníquese con su administrador de cuenta.',
      cardButton: 'Agregar nueva remesa',
      cardButton2: 'Agregar una remesa',
      eventAdd: 'Agregar remesa - Navegar al formulario de agregar remesa',
      eventView: 'Agregar remesa - Navegar al formulario de ver remesa',
      listCardStatus: {
        pending: 'Pago aún por citar',
        partial: 'Marcado parcial',
        marked: 'Remesa marcada'
      },
      listCardInvoiceSelected: 'Factura(s) seleccionada(s):',
      listCardRemittanceAmt: 'Monto de la remesa:',
      listCardButton: 'Ver remesa'
    },
    viewRemittance: {
      removeRemittance: 'Eliminar remesa',
      buyerDetailsTitle: 'Detalles del comprador y remitente',
      buyerDetails: [
        'Comprador',
        'Nombre del remitente/consignatario',
        'Ciudad del banco beneficiario'
      ],
      invoiceDetailsTitle: 'Detalles de la factura',
      invoiceDetails: [
        'Factura(s)',
        'Monto de la remesa',
        'Moneda de la factura'
      ],
      unFinancedInvoiceTitle: 'Factura no financiada',
      unFinancedInvoice: ['Banco', 'Monto', 'Narración'],
      upload: {
        title: 'Subir remesa',
        cardTitle: 'Copia/documento de remesa',
        cardSubtitle:
          'Solo se permiten archivos PDF e imágenes. El tamaño de cada archivo no debe ser superior a 10 MB.',
        downloadButton: 'Descargar'
      },
      textInput: 'Instrucciones adicionales con respecto a la remesa',
      textPlaceholder: 'Proporcione detalles específicos sobre esta remesa',
      deleteSuccess: 'Remesa eliminada correctamente',
      deleteFailed: '¡No se pudo eliminar la remesa!'
    },
    addRemittance: {
      breadcrumbMain: 'Remesas',
      breadcrumbText: 'Agregar una nueva remesa',
      heading: 'Agregar una remesa',
      inputs: [
        {
          heading: 'Detalles del comprador y remitente',
          label: 'Compradores',
          placeHolder: 'Seleccione un comprador'
        },
        {
          label: 'Nombre del remitente/tercero/consignatario:',
          placeHolder: 'Por ejemplo, ABC Company',
          checkboxText:
            'Haga clic aquí si el comprador y el remitente son los mismos.'
        },
        {
          label: 'Moneda de la remesa',
          placeHolder: 'Seleccione una moneda'
        },
        {
          label: 'Monto de la remesa',
          placeHolder: 'Por ejemplo, 45,900'
        },
        {
          heading: 'Detalles de la factura',
          subtext:
            'Puede ver las facturas según su comprador y la moneda seleccionada anteriormente.',
          label: 'Facturas',
          placeHolder: 'Seleccione varias facturas',
          error: 'Este es un error de factura'
        },
        {
          heading: 'Factura no financiada',
          label: 'Seleccionar banco',
          placeHolder: 'Seleccione un banco'
        },
        {
          label: 'Monto de la remesa (no financiado)',
          placeHolder: 'Por ejemplo, 45,900'
        },
        {
          label: 'Narración',
          placeHolder: 'Ingrese su narración'
        },
        {
          label: 'Instrucciones adicionales con respecto a la remesa',
          placeHolder: 'Proporcione detalles específicos sobre esta remesa'
        }
      ],
      uploads: {
        title: 'Subir remesa',
        cardTitle: 'Copia/documento de remesa',
        cardSubtitle:
          'Solo se permiten archivos PDF e imágenes. El tamaño de cada archivo no debe ser superior a 10 MB.',
        errorMessage: 'Se requieren copia/documentos de remesa.'
      },
      submitButton: 'Enviar remesa',
      submitSuccess: 'Remesa agregada correctamente'
    }
  },
  // error messages
  messages: {
    required: 'Este campo es requerido.',
    confirmed: 'La confirmación debe coincidir con la contraseña.',
    email: 'Este campo no es válido',
    min: (fieldName) =>
      `Este campo debe tener al menos ${fieldName} caracteres`,
    numeric: 'Este campo solo puede contener caracteres numéricos'
  },
  custom: {
    advance_received: {
      max_value:
        'El anticipo recibido no puede ser mayor que el monto de la factura'
    },
    gross_value: {
      min_value: 'El valor bruto debe ser superior a 0'
    }
  },
  alerts: {
    dashboard: {
      basicInfo:
        '1 factura carece de información crítica. | {count} facturas carecen de información crítica.',
      basicInfoCta: 'Ver factura | Ver facturas',
      docsPending:
        '1 factura carece de documentos críticos. | {count} facturas carecen de documentos críticos',
      docsPendingCta: 'Ver factura | Ver facturas',
      esignPending:
        '1 factura tiene documentos que necesitan de la firma electrónica. | {count} facturas tienen documentos que necesitan de la firma electrónica.',
      esignPendingCta: 'E-firmar documentos'
    },
    invoiceList: {
      docsPending: {
        title: 'Documentos pendientes',
        message:
          '1 factura tiene documentos importantes pendientes. | {count} factura tiene documentos importantes pendientes.',
        cta: 'Ver Factura | Ver Facturas'
      },
      basicInfoPending: {
        title: 'Información básica pendiente',
        message:
          '1 factura tiene información importante pendiente. | {count} factura tiene información importante pendiente.',
        cta: 'Ver Factura | Ver Facturas'
      },
      esignPending: {
        title: 'Firma electrónica pendiente',
        message:
          '1 factura tiene documentos que necesitan una firma electrónica. | {count} facturas tienen documentos que necesitan una firma electrónica.',
        cta: 'Documentos con firma electrónica'
      }
    },
    invoice: {
      docsPending: 'Esta factura carece de documentos críticos',
      docsPendingCta: 'Cargar documentos',
      esignPending:
        'Esta factura tiene documentos que necesitan de la firma electrónica',
      esignPendingCta: 'E-firmar documentos'
    }
  },
  chat: {
    inputPlaceholder: 'Comienza a teclear...'
  },
  importers: {
    invoices: {
      title: 'Facturas',
      pending: 'Adelanto pendiente',
      outstanding: 'Adelantado',
      received: 'Liquidación pendiente',
      settled: 'Liquidado',
      searchResults: 'Buscar resultados para',
      noInvoices:
        'No se encontraron facturas con los filtros actuales. Por favor cambia los filtros o intenta términos de búsqueda distintos.',
      searchInvoice: 'Buscar una factura...',
      invoiceTableFields: [
        {
          key: 'exporter',
          label: 'Exportador'
        },
        {
          class: 'po-col',
          key: 'po_no',
          label: 'Orden de compra #'
        },
        {
          key: 'reference',
          label: 'Referencia de la factura'
        },
        {
          key: 'invoice_date',
          label: 'Fecha de la factura'
        },
        {
          key: 'importer',
          label: 'Importador'
        },
        {
          key: 'value',
          label: 'Monto neto a pagar'
        },
        {
          key: 'repayment',
          label: 'Fecha límite'
        },
        {
          key: 'documents_public',
          label: 'Acciones'
        }
      ]
    },
    index: {
      noDocs:
        'No pudimos encontrar ninguna factura que requiera una firma electrónica.',
      ack: {
        toBeEsigned:
          'Las siguientes facturas tienen confirmaciones a ser e-firmadas:',
        esignNow: 'E-firmar ahora'
      },
      boe: {
        toBeEsigned:
          'Las siguientes facturas tienen letras de cambio que deben ser e-firmadas:',
        esignNow: 'E-firmar ahora'
      },
      invoicesListTable: [
        {
          key: 'selected',
          label: ''
        },
        {
          key: 'exporter',
          label: 'Exportador'
        },
        {
          class: 'po-col',
          key: 'po_no',
          label: 'Orden de compra #'
        },
        {
          key: 'reference',
          label: 'Referencia de la factura'
        },
        {
          key: 'invoice_date',
          label: 'Fecha de la factura'
        },
        {
          key: 'importer',
          label: 'Importador'
        },
        {
          key: 'value',
          label: 'Monto neto a pagar'
        },
        {
          key: 'repayment',
          label: 'Fecha límite'
        },
        {
          key: 'documents_public',
          label: 'Acciones'
        }
      ]
    }
  },
  common: {
    invoiceAdvice: 'Factura Consejo',
    invoiceSwift: 'Copia SWIFT',
    invoiceNoc: 'Documento Noc',
    downloads: 'Descargas',
    print: {
      to: 'Para,',
      local: 'Para correspondencia en México'
    },
    alert: {
      viewInvoices: 'Ver facturas'
    },
    address: {
      us: {
        company: 'Drip Capital Inc.',
        line1: '555 Bryant St. #356,',
        line2: 'Palo Alto, CA 94301'
      },
      local: {
        company: 'Drip Capital México',
        line1: 'Paseo de la Reforma 296,',
        line2: 'Juárez, 06600 Ciudad de México'
      },
      website: 'https://www.dripcapital.mx'
    }
  },
  login: {
    emailLogin: 'Accesar con email',
    phoneLogin: 'Accesar con número de teléfono',
    login: 'Acceso',
    emailForm: {
      email: 'Email',
      password: 'Contraseña',
      forgotPassword: '¿Olvidaste tu contraseña?'
    },
    phoneForm: {
      phone: 'Número de teléfono',
      getOtp: 'Obtener OTP',
      otp: 'OTP'
    },
    sendResetLink: 'Enviar hipervínculo para restablecer',
    backToLogin: 'Regreso a la página de inicio',
    emailSent:
      'Te hemos enviado un correo. Por favor revisa tu bandeja de entrada para más instrucciones.',
    newPass: 'Nueva contraseña',
    confirmPass: 'Confirmar contraseña',
    resetPass: 'Restablecer contraseña'
  },
  newLogin: {
    heading: 'Log in',
    emailSubHeading:
      'Inicie sesión en su cuenta a continuación utilizando su correo electrónico.',
    phoneSubHeading:
      'Inicie sesión en su cuenta a continuación con su número de teléfono.',
    emailForm: {
      emailLabel: 'Dirección de correo electrónico',
      emailPlaceholder: 'Example@gmail.com',
      passwordLabel: 'Clave',
      passwordPlaceholder: 'Ingresa tu contraseña',
      checkbox: 'Acuérdate de mí',
      forgotPassword: 'Has olvidado tu contraseña?',
      loginButton: 'Acceso',
      link1: '¿No tienes una cuenta? Inscribirse',
      or: 'o',
      link2: 'No recuerdo tu ID de correo electrónico',
      phoneLogin: 'Iniciar sesión con número de teléfono'
    },
    phoneForm: {
      phoneLabel: 'Número de teléfono',
      placeholder: 'Eg: 9892350750',
      getOtp: 'Generar OTP',
      link1: '¿No tienes una cuenta? Inscribirse',
      or: 'o',
      link2: 'No recuerdo tu número de teléfono',
      emailLogin: 'Iniciar sesión con correo electrónico',
      enterOtp: 'Ingresar OTP',
      otpMsg:
        'Hemos enviado una contraseña de un solo uso (OTP) a su número de teléfono “{phone}”. Ingrese OTP para verificar e iniciar sesión',
      numberChange:
        '¿El número de teléfono no es correcto? cambiar número de teléfono',
      verify: 'Verificar e iniciar sesión',
      link3: '¿No recibiste la contraseña de un solo uso?',
      resendOtp: 'Reenviar OTP',
      link4: '¿No tienes una cuenta? Inscribirse',
      info: 'No recuerdo tu número de teléfono'
    },
    success: {
      text: 'Tu correo electrónico está verificado',
      description:
        'Hemos verificado su correo electrónico, puede iniciar sesión ahora con su contraseña establecida'
    },
    error: {
      linkText: 'Forgot Password?',
      text: '<p class="mb-0"><strong>Sorry we’re not able to get you logged in</strong></p>',
      description:
        'We are not able to match the user name and password. Do you want to reset your password?'
    },
    registration: {
      text: 'El registro de su cuenta fue exitoso',
      description: 'Inicie sesión con sus credenciales establecidas'
    },
    resetPassword: {
      text: 'Tu restablecimiento de contraseña fue exitoso',
      description: 'Inicie sesión con sus credenciales establecidas'
    }
  },
  newResetPassword: {
    heading: 'Restablecer la contraseña',
    subHeading: 'Por favor ingrese una contraseña deseada',
    email: 'Correo electrónico',
    resetForm: {
      passwordLabel: 'Crear contraseña',
      confirmLabel: 'Confirmar contraseña',
      resetButton: 'Restablecer contraseña e iniciar sesión',
      or: 'o',
      link1: 'Cambia tu correo electrónico o número de teléfono ?',
      info: 'Póngase en contacto con nuestros servicios de atención al cliente. Ellos le ayudarán a actualizar su correo electrónico y número de teléfono.'
    },
    success: {
      text: 'El correo electrónico de verificación se envió con éxito',
      description:
        'Hemos verificado su correo electrónico, puede iniciar sesión ahora con su contraseña establecida'
    },
    error: {
      text: '<p class="mb-0"><strong>No pudimos encontrar su cuenta</strong> No podemos encontrar una cuenta asociada con el <strong>“{email}”</strong></p>'
    },
    validations: {
      minMax: 'Contiene 8-14 caracteres',
      upperCase: 'Un carácter en mayúscula',
      splChar: 'Un personaje especial',
      oneDigit: 'Un número'
    }
  },
  newForgotPassword: {
    heading: 'Has olvidado tu contraseña',
    subHeading:
      'Por favor ingrese su correo electrónico para restablecer su contraseña',
    or: 'o',
    loginLink: 'Volver para iniciar sesión',
    forgotForm: {
      emailLabel: 'Dirección de correo electrónico',
      emailPlaceholder: 'Example@gmail.com',
      resetButton: 'Enviar enlace de reinicio',
      or: 'o',
      link1: 'Cambia tu correo electrónico o número de teléfono ?',
      info: 'Si desea cambiar su correo electrónico o número de teléfono, comuníquese con nuestros servicios de atención al cliente.'
    },
    success: {
      text: 'El mensaje de verificación ha sido enviado',
      description:
        'Hemos verificado su correo electrónico, puede iniciar sesión ahora con su contraseña establecida'
    },
    error: {
      text: `<p class="mb-0"><strong>We were not able to find your account</strong> We are not able to find an account associated with the <strong>"{email}"</strong></p>`
    }
  },
  confirmEmail: {
    heading: 'confirme su email',
    link1_1: 'Revisa tu bandeja de entrada en',
    link1_email: 'steve.jennings@gmail.com',
    link1_2: 'y haga clic en el enlace para restablecer su contraseña.',
    link2_question: 'email incorrecto?',
    link2_link: 'Cambiar e-mail',
    info: 'Si no ha recibido un correo electrónico, revise su carpeta de spam o promociones o reenvíe el correo electrónico.',
    resend: 'Reenviar email',
    link3_question: '¿Ya verificó el correo electrónico?',
    link3_link: 'Acceso',
    msg: 'El correo electrónico de verificación se envió con éxito a la dirección de correo electrónico mencionada'
  },
  notifications: {
    title: 'Mensaje importante',
    login: {
      title: 'Error',
      text: 'Credenciales inválidas.'
    },
    esign: {
      title: 'Éxito',
      text: 'El proceso de e-firma ha sido completado exitosamente.'
    },
    importers: {
      title: 'Éxito',
      text: 'El proceso de e-firma ha sido completado exitosamente.'
    },
    somethingWrong: {
      title: 'Error',
      text: 'Algo ha salido mal. Estamos revisándolo.'
    },
    buyerAdded: {
      title: 'Éxito',
      text: 'Adición de comprador solicitada exitosamente.'
    },
    passwordError: {
      title: 'Error',
      text: 'Algo ha salido mal. Por favor escríbenos a cs@dripcapital.com para asistencia.'
    },
    resetPassword: {
      title: 'Éxito',
      text: 'Tu contraseña ha sido restablecida.'
    }
  },
  public: {
    invoices: {
      unauthorized: 'You are not authorized to view this document.'
    }
  },
  passbook: {
    title: 'Bienvenido a Passbook',
    subtitle: 'Consulta y administra todas tus transacciones aquí',
    lead: 'Empieza seleccionando todos los parámetros que desees consultar',
    invoiceNumber: 'Numero de factura',
    noData: 'Sin Datos',
    openingBalance: 'Saldo de apertura',
    closingBalance: 'Balance de cierre',
    download: 'Descargar como Excel',
    placeHolder: 'Busque un número de referencia o un comprador…',
    sidebar: {
      labels: {
        view: 'Ver',
        date: 'Fecha',
        from: 'Desde',
        to: 'A',
        currency: 'Moneda',
        transactionType: 'Tipo de transacción',
        buyers: 'Compradores',
        apply: 'Aplicar'
      },
      options: {
        views: [
          // { text: 'Bank Transactions', value: 'transactions' },
          { text: 'Declaración', value: 'statement' }
        ],
        dates: [
          { text: 'Este mes', value: 'current' },
          { text: 'Mes pasado', value: 'last' },
          { text: 'Rango de fechas', value: 'range' }
        ],
        transactionTypes: [
          { text: 'Adelanto', value: 'advance' },
          { text: 'Pago', value: 'payment' },
          { text: 'Asentamiento', value: 'settlement' },
          { text: 'Cargos', value: 'charges' }
        ],
        buyers: [{ value: '', text: 'Todos los compradores' }]
      }
    }
  },
  invoiceFilters: {
    pending: 'Pendiente',
    processing: 'Procesando',
    approved: 'Aprobado',
    advanced: 'Adelantado',
    paid: 'Pagado',
    settled: 'Liquidado'
  },
  invoiceTableFields: [
    {
      key: 'reference',
      label: 'Factura#',
      class: 'reference-cell pl-1 pl-md-3',
      sortable: true
    },
    {
      key: 'importer',
      label: 'Comprador',
      class: 'buyer-cell',
      sortable: true
    },
    {
      key: 'value',
      label: 'Valor de factura neto',
      sortable: true
    },
    {
      key: 'advanced_date',
      label: 'Fecha de adelanto'
    },
    {
      key: 'total_advanced',
      label: 'Monto adelantado'
    },
    {
      key: 'charges',
      label: 'Cargos'
    },
    {
      key: 'repayment',
      label: 'Fecha de vencimiento'
    },
    {
      key: 'stage_human',
      label: 'Estatus',
      class: 'status-cell'
    },
    {
      key: 'action',
      label: 'Actions'
    }
  ],
  invoiceTableItems: {
    expected: 'Previsto',
    charged: 'Cobrado',
    status: {
      'Exporter E-Sign Pending': 'Efirmar Requerido',
      'Exporter E-Sign Generated': 'Efirmar Requerido',
      'Invoice Processing': 'Procesando',
      'Docs Pending': 'Documentos pendientes',
      'Basic Info Pending': 'Basic Info Pending',
      Hold: 'Hold',
      Pending: 'Pendiente',
      Processing: 'Procesando',
      Approved: 'Aprobado',
      Advanced: 'Adelantado',
      Paid: 'Pagado',
      Settled: 'Liquidado',
      'Buyer E-Sign Pending': 'Firma electrónica de comprador pendiente',
      'Partial Advanced': 'Adelantado parcialmente',
      'Partial Payment': 'Pago parcial',
      'Pending Settlement': 'Liquidación pendiente',
      Draft: 'Borrador',
      'Auto Advanced': 'Auto Adelantado',
      NPA: 'NPA',
      'Collection Only': 'Collection Only',
      Claim: 'Afirmar',
      Outdated: 'Anticuado',
      'Auto Settled': 'Auto Liquidado',
      Overdue: 'Overdue',
      'Follow Up': 'Follow Up',
      'ETD Check': 'ETD Check',
      'FDA Check': 'FDA Check',
      'Due in 15 Days': 'Due in 15 Days',
      'Due in 5 Days': 'Due in 5 Days',
      'Due in 1 Day': 'Due in 1 Day',
      'GUD Check': 'GUD Check',
      'Deposit Added': 'Deposit Added',
      'Physical Docs Pending': 'Physical Docs Pending',
      Revised: 'Revisado',
      'Revision Pending': 'Revisión pendiente',
      'Review and Submit': 'sRevisión Pendiente',
      'E-Sign Pending': 'E-firmar Pendiente'
    }
  },
  searchForm: {
    placeholder: 'Buscar un factura'
  },
  multiselect: {
    selectLabel: 'Presione enter para seleccionar',
    deSelectLabel: 'Presione enter para eliminar',
    selectedLabel: 'Seleccionada'
  },
  networkErrList: {
    defaultMsg: 'Se produjo un error, Vuelve a intentarlo más tarde',
    400: 'Solicitud incorrecta',
    401: 'No autorizado',
    402: 'Pago requerido',
    403: 'Prohibida',
    404: 'No encontrada',
    405: 'Método no permitido',
    406: 'Inaceptable',
    407: 'Se requiere autenticación proxy',
    408: 'Pide tiempo fuera',
    409: 'Conflicto',
    410: 'Desaparecida',
    411: 'Longitud requerida',
    412: 'Condición previa Falló',
    413: 'Carga útil demasiado grande',
    414: 'URI demasiado larga',
    415: 'Tipo de medio no admitido',
    416: 'Rango no satisfactorio',
    417: 'Expectativa fallida',
    418: 'Soy una tetera',
    421: 'Solicitud mal dirigida',
    422: 'Entidad no procesable',
    423: 'Bloqueada',
    424: 'Dependencia fallida',
    425: 'Demasiado temprano',
    426: 'Se requiere actualización',
    428: 'Requisito previo',
    429: 'Demasiadas solicitudes',
    431: 'Campos de encabezado de solicitud demasiado grandes',
    451: 'No disponible por motivos legales',
    500: 'Error de servidor interno',
    501: 'No implementada',
    502: 'Puerta de enlace incorrecta',
    503: 'Servicio no disponible',
    504: 'Tiempo de espera de puerta de enlace',
    505: 'Versión HTTP no admitida',
    506: 'La variante también negocia',
    507: 'Espacio insuficiente',
    508: 'Bucle detectado',
    510: 'No extendida',
    511: 'Se requiere autenticación de red'
  },
  bankAccounts: {
    title: 'Bank Accounts',
    desc: 'Below is the list of banks you have added',
    addBankBtn: 'Add Bank Account',
    addBankDisabledText: 'No estás autorizado a proceder',
    verified: 'Verified',
    verificationPending: 'Verification pending',
    view: 'View',
    beneficiaryBankDetails: 'Beneficiary bank details',
    archivedTitle: 'Archived bank accounts(Not in use)',
    archivedDesc: 'Their are no archived bank accounts',
    archived: 'Archived',
    archivalPending: 'Archival Pending',
    archiveAccount: 'Archive account',
    accountNumber: 'Account Number',
    beneficiaryName: 'Beneficiary Name',
    bankName: 'Bank Name',
    bankCity: 'Bank City',
    ifscCode: 'IFSC code',
    swiftCode: 'Swift Code',
    fedwireABA: 'FEDWIRE ABA',
    accountType: 'Bank Account Type',
    cancelledCheque: 'Cancelled cheque',
    download: 'Download',
    eefcLetter: 'EEFC Letter',
    correspondentBankDetails: 'Correspondent bank details',
    currency: 'Currency',
    archivalConsent: {
      title: 'Are you sure you want to archive this bank information?',
      desc: 'Once you archive the account your not able to use this bank account for you future bank payments',
      action: {
        yes: 'Yes, Archive',
        no: 'No, dont archive'
      }
    },
    archivalSuccess: {
      msg: `We've recorded your request to archive this bank information. We will send you a confirmation once it's approved from our systems`,
      action: {
        gotIt: 'Got it'
      }
    }
  },
  pdc: {
    title: 'Post dated cheque details',
    desc: 'Enter these details on a cheque while sending PDC to the drip capital.',
    pay: 'Pay',
    learnMore: 'Learn More',
    payDesc: `This is the entity you're making the cheque for, in this case Drip Capital Services`,
    payValue: 'DRIP CAPITAL SERVICES INDIA LLP',
    invAmtLabel: 'Invoice amount in numbers',
    invAmtWordsLabel: 'Invoice amount in words',
    date: 'Date',
    dateDesc: `Date on the post dated cheque is calculated as per Drip Capital's policies`,
    sampleCheque: 'Sample cheque'
  },
  invoiceStage: {
    discrepant: 'Revision pending',
    revised: 'Processing'
  },
  clickWrap: {
    heading1: 'Invoice Documents dated',
    heading2:
      'Please read the document(s) carefully and scroll to the bottom to accept and E-sign.',
    consentTitle:
      'Please provide your consent by clicking on the check box. You can only E-sign after clicking on the checkbox.',
    consentText:
      'I have read and understood the document and agree to the information contained therein. By typing my name into the box, I attest that I am the person authenticated into this request or an authorized signatory for the Client, and the data/information I am entering/verifying is accurate and true to the best of my knowledge.',
    inputLabel: 'Signature',
    inputButton: 'Completar firma electrónica',
    scrollToBottom: 'Scroll to bottom',
    validations: {
      required: 'Your name is required',
      alpha: 'Please remove any special characters (.,/,<,>,*, %)'
    },
    esignPostLoading: 'Processing your E-sign',
    esignDocumentIdMissing: 'Document could not be fetched!',
    esignFailedAlert: {
      title: 'E-sign Failed',
      text: 'Failed to sign the document(s).'
    },
    esignNotFoundAlert: {
      title: 'E-sign Failed',
      text: 'Something went wrong!'
    }
  },
  bank: {
    list: {
      page: 'Cuentas bancarias',
      accounts: {
        editButton: 'Ver/Editar detalles',
        viewButton: 'Ver cuenta'
      },
      addMoreBanks: {
        title: 'Agregar una nueva cuenta bancaria',
        subtitle:
          'Puede agregar nuevas cuentas bancarias y editar sus detalles mientras se encuentran en la etapa de verificación.',
        button: 'Agregar cuenta bancaria'
      }
    },
    addBank: {
      header: 'Agregar cuenta bancaria',
      headerUpdate: 'Editar cuenta bancaria',
      title: 'Datos del banco beneficiario',
      form: {
        title: 'Detalles de la cuenta bancaria de',
        subtext:
          'Solo puedes editar tus datos bancarios cuando el banco esté pendiente de verificación.',
        beneficiary_name: {
          label: 'Nombre del Beneficiario',
          placeholder: 'p.ej. Nombre ABC'
        },
        bank_name: {
          label: 'Nombre del banco beneficiario',
          placeholder: 'p.ej. Nombre del banco ABC'
        },
        bank_city: {
          label: 'Beneficiary bank city',
          placeholder: 'p.ej. California'
        },
        beneficiary_account: {
          label: 'Beneficiary account number/IBAN',
          placeholder: 'p.ej. 123456789'
        },
        swift_code: {
          label: 'SWIFT Code',
          placeholder: 'p.ej. ABCDEFGHKLM',
          errorMessage: 'Minimum 8 and maximum 11 characters.'
        },
        currency: {
          label: 'Currency',
          placeholder: 'p.ej. USD'
        },
        supporting_document: {
          header: 'Cargar documento de respaldo',
          title:
            'Para confirmar los detalles de su cuenta, cargue cualquiera de los siguientes:',
          subtitle:
            'Cheque cancelado / Carta EEFC / Primera página de libreta o extracto bancario',
          label: 'Documento de apoyo',
          subtext:
            'Cargue un documento de respaldo para verificar sus datos bancarios.',
          placeholder: 'p.ej. USD'
        },
        correspondingDetails: {
          title: 'Detalles del banco corresponsal',
          subtext:
            'Nota: Como el banco JP Morgan es nuestro socio bancario, utilice cualquier otro banco como banco corresponsal.'
        },
        cor_bank_name: {
          label: 'Nombre del banco corresponsal',
          placeholder: 'p.ej. Nombre del banco ABC'
        },
        cor_bank_swift_code: {
          label: 'Código SWIFT del banco corresponsal',
          placeholder: 'p.ej. ABCDEFGHKLM'
        },
        uploads: {
          bank_supporting_document: {
            title: 'Documento de apoyo',
            subtext:
              'Cargue un documento de respaldo para verificar sus datos bancarios.',
            errorMessage: 'Se requieren documentos de respaldo.'
          }
        },
        buttonUpdate: 'Actualizar datos bancarios',
        buttonAddBank: 'Adición bancaria completa'
      },
      successAddBank: 'Tu banco ha sido agregado',
      successUpdateBank: 'Datos bancarios actualizados correctamente'
    },
    view: {
      subtext:
        'Puede editar su proveedor y los datos bancarios de su proveedor mientras se encuentran bajo verificación. Le notificaremos una vez que estén verificados.',
      contact: {
        title: 'Detalles del banco'
      },
      company: {
        title: 'Datos del banco beneficiario',
        name: 'Nombre del Beneficiario',
        bank_name: 'Nombre del banco beneficiario',
        bank_city: 'Ciudad del banco beneficiario',
        account_number: 'Número de cuenta del beneficiario / IBAN',
        swift_code: 'Código SWIFT',
        currency: 'Divisa',
        documentsTitle: 'Cargar documento de respaldo',
        documentsSubtitle:
          'Para confirmar los detalles de su cuenta, cargue cualquiera de los siguientes: Cheque cancelado / Carta EEFC / Primera página de la libreta o extracto bancario',
        corresponding_name: 'Nombre del banco corresponsal',
        corresponding_swift_code: 'Código SWIFT del banco corresponsal',
        pci: {
          title: 'Supporting Document',
          subtext:
            'Cargue un documento de respaldo para verificar sus datos bancarios.'
        },
        uploads: {
          downloadBtn: 'Descargar'
        }
      },
      bank: {
        title: 'Datos bancarios del proveedor',
        accountNumber: 'Número de cuenta',
        abaRouting: 'Número ABA',
        swift: 'Código SWIFT/número ABA',
        currency: 'Divisa'
      }
    }
  },

  accountSummary: {
    back: 'Atrás',
    heading: 'Resumen de la cuenta',
    title: 'Detalles de su cuenta',
    accountSummaryFields: [
      {
        key: 'accountName',
        label: 'Nombre de la cuenta',
        class: 'reference-cell pl-1 pl-md-3',
        sortable: false
      },
      {
        key: 'totalFacility',
        label: 'Límite de instalaciones totales',
        class: 'reference-cell pl-1 pl-md-3',
        sortable: false
      },
      {
        key: 'usedFacility',
        label: 'Límite de instalaciones utilizadas (como en la fecha actual)',
        class: 'reference-cell pl-1 pl-md-3',
        sortable: false
      }
    ],
    note: {
      title: 'Descargar resumen de cuenta:',
      list_item_1:
        'The account summary will only include invoices which are advanced.',
      list_item_2:
        'Las tarifas se calcularán en la fecha actual (hoy) para facturas adelantadas y vencidas.'
    },
    buyer: {
      title: 'Seleccione un comprador:',
      label: 'Compradores'
    },
    date_range: {
      title: 'Seleccione un rango de fechas:',
      option_1: 'últimos 30 días',
      option_2: 'últimos 3 meses',
      option_3: 'último ejercicio financiero'
    },
    date: {
      or: 'O',
      from: 'De',
      to: 'A',
      validation: 'La fecha desde debe ser anterior a la fecha hasta',
      download_button: 'Descargar resumen'
    }
  },
  error: {
    unableToProcess: 'No se puede procesar su solicitud',
    unauthorizedToolTip: 'No estás autorizado a continuar',
    unauthorizedPage: 'No estás autorizado a acceder a la página.',
    unauthorizedAccess: 'Tu no tienes los permisos requeridos'
  },
  legal: {
    page1: {
      mainTitle: 'E-sign Legal Agreement',
      subtitle: 'The legal agreement contains the following documents:',
      documents: [
        'RPA',
        'Schedule I',
        `UDC Undertaking (Please keep your UDC's handy)`,
        'Appointment Agent',
        'LOA/Sole Proprietorship Letter'
      ],
      title: 'Select a date and city for your legal agreement:',
      date: {
        label: 'Date',
        placeholder: 'Select a date'
      },
      city: {
        label: 'City',
        placeholder: 'Enter your city'
      },
      button: 'Generate legal agreement',
      nonSignatoryMessage1: 'You are not authorised to E-sign.',
      nonSignatoryMessage2:
        'Please log-in from an authorised signatory account to proceed with E-sign.',
      mandatoryInformation: {
        title: 'Mandatory steps after E-sign:',
        subtext:
          'Kindly courier the original undated cheques to our Mumbai office as a mandatory verification step for invoice funding.'
      },
      companyInformation: {
        title: 'Drip Capital Services India LLP Mumbai',
        subtext:
          '1221, 2nd Floor, Building 12 Solitaire Corporate Park, Guru Hargovindji Rd, Chakala, Andheri East, Mumbai, Maharashtra 400093'
      },
      additionalContact:
        'If you have questions, please contact your sales manager {name} '
    },
    page2: {
      loaderText: 'Re-directing you to Drip Portal',
      mainTitle: 'Adobe E-sign',
      subtitle:
        "Kindly read through the legal agreement and follow Adobe's instructions to sign the same.",
      subtext:
        'If you have questions, please contact your sales manager {name}',
      button: 'Update date and city',
      download: 'Download agreement',
      esignSuccess: {
        title: 'E-sign successful!',
        message:
          "This screen will time-out in 10-15 seconds and you will be re-directed to Drip's portal.."
      }
    },
    banner: {
      title: 'Welcome to Drip Portal!',
      description:
        'Your e-signed legal agreement copy has been emailed to you.',
      stepTitle: 'Mandatory steps to get your invoice funded:',
      instruction:
        'Kindly courier the physical post dated/undated cheques to our Mumbai office for invoice funding.',
      clickHere: 'Click here',
      address: 'for complete address.',
      bottomText:
        'Please add a bank account and upload your invoice for underwriting.',
      note: 'Note: Till the time we do not receive your cheques, we cannot fund your invoices.',
      getStarted: 'Get started'
    }
  },
  digilocker: {
    verify: {
      error:
        'Your Digilocker link is no longer valid. Please generate a new link to continue.',
      heading: 'Drip Capital',
      body1:
        "As a part of Drip Capital's onboarding journey, you need to verify your Aadhaar details securely via DigiLocker, a government-approved digital document storage system.",
      body2:
        'To verify your identity, a one-time password (OTP) will be sent to your registered mobile number.',
      link: 'How to verify your Aadhar? Watch the video guide >',
      consent: {
        title: 'Please click on the checkbox below to start your KYC Process.',
        body: 'I hereby provide my consent to Drip Capital Services LLP to access my DigiLocker contact details and use it for financing purpose only.'
      },
      button: 'Start KYC'
    },
    status: {
      success: {
        heading: 'Thank you',
        title: 'KYC Process Successfully Completed',
        body: 'Thank you for completing the DigiLocker KYC. Our team will now review your details and update you shortly'
      },
      failed: {
        heading: 'KYC Unsuccessful',
        title: 'Unable to Complete Your KYC',
        body: 'Unfortunately, we were unable to complete your DigiLocker KYC. Please check your details and try again or contact our support team for assistance.'
      }
    }
  }
}
